export default __webpack_public_path__ + "static/media/Gustixa - past lives remix.c72ae6ab.mp3";